// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1uqEG","selects":"Documents_selects__3mrHm"};